const AIDesk = {
	"结束会话": "Selesai",
	"转人工服务": "Layanan manusia",
	"跳转": "Goto",
	"立即填写": "Isi sekarang",
	"已提交": "Terkirim",
	"提交": "Kirim",
	"查看内容": "Lihat konten",
	"请填写必填项": "Harap isi bidang yang wajib diisi",
	"请输入内容":"Silakan masukkan konten",
	"如果满意请给好评哦～":"Jika Anda puas, silakan berikan ulasan yang bagus~",
	"请对本次服务进行评价": "Silakan beri penilaian untuk layanan ini",
	"提交评价": "Kirim Ulasan",
	"服务评价": "Ulasan Layanan",
	"并发限制": "Saat ini banyak pengguna yang mengakses. Mohon coba lagi nanti",
	"分支选项异常": "Konten tidak normal, silakan periksa konfigurasi alur tugas",
	"满意": "Puas",
	"不满意": "Tidak puas",
	"感谢您的反馈，我们会持续优化改进": "Terima kasih atas masukan Anda, kami akan terus memperbaiki",
	"您遇到了哪方面的问题": "Masalah apa yang Anda hadapi",
	"其他反馈内容": "Masukan lainnya",
	"取消": "Batal",
	"答非所问": "Jawaban tidak relevan",
	"未匹配相关内容": "Tidak ada konten yang cocok",
	"信息错误": "Informasi salah",
	"上下文理解错误": "Kesalahan pemahaman konteks",
	"格式不规范": "Format tidak standar",
	"内容不完整": "Konten tidak lengkap",
	"file 大小超过 100MB，无法发送": "Ukuran file melebihi 100MB, tidak dapat dikirim",
	"image 大小超过 20MB，无法发送": "Tidak dapat mengirim gambar karena melebihi 20 MB",
  "video 大小超过 100MB，无法发送": "Tidak dapat mengirim video karena melebihi 100 MB",
	"提交成功": "Berhasil dikirim",
	"userID 只能包含可打印 ASCII 字符": "UserID hanya boleh berisi karakter ASCII yang dapat dicetak",
  "userID 不能包含'administrator'": "UserID tidak boleh mengandung 'administrator'",
  "userID 长度不能超过45字节": "Panjang UserID tidak boleh melebihi 45 byte",
	"我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "Kami menghargai masukan Anda. Silakan bagikan saran apa pun untuk membantu kami meningkatkan layanan.",
	"排队等待中": "Sedang antre",
  "排队等待话术": "Mohon maaf, seluruh customer service kami sedang sibuk. Silakan tunggu dengan sabar, kami akan segera membantu Anda. Terima kasih atas pengertiannya.",
  "当前前方排队人数": "Jumlah orang di depan antrian saat ini",
  "结束排队": "Keluar dari antrian",
	"评价提交超过3分钟，无法更改。感谢您的反馈！": "Ulasan yang dikirim lebih dari 3 menit tidak dapat diubah.",
	"不能发送空白消息": "Tidak dapat mengirim pesan kosong",
	"确认转人工": "Konfirmasi transfer ke agen",
}
export default AIDesk;
